import axios from 'api/axios'
import { Template, TemplateStatus } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface of objects that can be used in the API for getTemplate
 */

export interface GetTemplateParams {
	page: number
	size: number
	status?: TemplateStatus | string
	client?: string
}

/**
 * Type Interface for the Response object you get from getTemplate request if successful
 */
export interface TemplateResponse {
	totalCount: number
	records: Template[]
	totalPages: number
	currentPage: number
}

export interface GetTemplateResponse {
	response: TemplateResponse
	filter: {
		status: string
	}
}

/**
 * API call to get Template from the WhatCX Application
 * @param options getTemplateParams - Options for the API call
 * @returns TemplateResponse - Response object returned from the server
 */

export const getTemplates = async (
	params: GetTemplateParams
): Promise<GetTemplateResponse> => {
	try {
		const { data } = await axios.get<GetTemplateResponse>(`templates/list`, {
			params,
		})

		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default getTemplates
